import { Author } from "../../user/objects/author";
import { Column } from "./column";
import { Preferences } from "../../profile/objects/preferences";
import { MarketView } from "../../marketView/objects/marketView";

/**
 * F1 & F2 : Masquage des prix dans le panier
 * Règles de visibilité des prix par catégorie et par produit
 */

// Catégories de produit pour le masquage par catégorie (F1)
export enum PriceDisplayCategory {
    HOTELS = 'HOTELS',
    FLIGHTS = 'FLIGHTS',
    TRANSFERS = 'TRANSFERS',
    ACTIVITIES = 'ACTIVITIES',
    CARS = 'CARS',
    INSURANCES = 'INSURANCES',
}

// Mode de masquage des prix (F2)
export enum PriceDisplayMode {
    DISPLAY_ALL = 'DISPLAY_ALL',                 // Afficher tous les prix (produit + Catégorie)
    HIDE_ALL = 'HIDE_ALL',                       // Masquer tous les prix du panier (produit + Catégorie)
    HIDE_PRODUCT_ONLY = 'HIDE_PRODUCT_ONLY',     // Masquer les prix des produits individuels uniquement
    HIDE_CATEGORY_ONLY = 'HIDE_CATEGORY_ONLY',   // Masquer les prix des catégories uniquement
}

export interface FunnelPriceDisplayRule {
    id?: number;
    name: string;
    localization: FunnelPriceDisplayRuleLocalization[];

    // Marchés cibles (optionnel - liste globale)
    markets: MarketView[];

    // Masquage par catégorie (F1) - catégories cochées = masquées
    hidden_categories: PriceDisplayCategory[];

    // Mode de masquage des prix (F2)
    display_choice: PriceDisplayMode;

    created_date?: Date;
    modified_date?: Date;
    creator?: null | Author;
    last_author?: null | Author;
}

export interface FunnelPriceDisplayRuleLocalization {
    name: string;
    id?: number;
    locale: number;
}

export interface FunnelPriceDisplayRuleForm {
    id?: number;
    name: string;
    name_localized: Record<number, string>;
    localization: FunnelPriceDisplayRuleLocalization[];

    markets: MarketView[];

    hidden_categories: PriceDisplayCategory[];
    display_choice: PriceDisplayMode;
}

export interface FunnelPriceDisplayRulePayload {
    id?: number;
    name: string;
    localization: FunnelPriceDisplayRuleLocalization[];
    markets: number[];
    display_choice: PriceDisplayMode;
    cms: number;
    funnel: number;
}

export interface FunnelPriceDisplayRuleListCriteria {
    limit: number;
    page: number;
    order: 'desc' | 'asc';
    order_by: string;
    search: string;
    cms_id?: number | null;
    funnel_id?: number | null;
}

export interface FunnelPriceDisplayRuleListConfiguration {
    columns: Column[];
    preferences: Preferences[];
}
